import StepIndicator from "../../components/Onboarding/StepIndicator";

export default function index() {
  return (
    <div className="font-Manrope px-4 max-w-7xl mx-auto py-10">
      <StepIndicator step={2} />
    </div>
  );
}
